export enum VipSystemTabsEnum {
  TASKS_SETTINGS = 'VIP tasks settings',
  LEVELS_SETTINGS = 'VIP levels settings',
  USERS_SETTINGS = 'VIP users settings',
  WHEEL_SETTINGS = 'VIP wheel settings',
  VIP_CHAT = 'VIP chat',
}
